import { hot } from 'react-hot-loader';
import { Switch, Route, Redirect } from 'react-router-dom';
//import Loadable from 'react-loadable';
import { routerPaths } from './helper';
import ErrorBoundary from '../components/ErrorBoundary';

import HomePage from '../pages/HomePage';
//import HowToBuyPage from '../pages/HowToBuyPage';
import TermsPage from '../pages/TermsPage';
import DetaisPage from '../pages/DetaisPage';
//import WalletPage from '../pages/WalletPage';
//import RnctPage from '../pages/RnctPage';
//import ContractsPage from '../pages/ContractsPage';
import IpfsPage from '../pages/IpfsPage';
import TraitsPage from '../pages/TraitsPage';
//import VotingPage from '../pages/VotingPage';
//import BurnPage from '../pages/BurnPage';
import WalletPage2 from '../pages/WalletPage2';



function AppRouter() {
  return (
    <ErrorBoundary>
      <Switch>
        <Route exact path={routerPaths.main} component={HomePage} />
        {/*<Route exact path={routerPaths.howToBuy} component={HowToBuyPage} />*/}
        <Route exact path={routerPaths.traits} component={TraitsPage} />
        <Route exact path={routerPaths.ipfs} component={IpfsPage} />
        <Route exact path={routerPaths.terms} component={TermsPage} />
        {/*<Route exact path={routerPaths.rnct} component={RnctPage} />
        <Route exact path={routerPaths.contracts} component={ContractsPage} />*/}
        <Route exact path={routerPaths.details} component={DetaisPage} />
        <Route exact path={routerPaths.wallet} component={WalletPage2} />
        {/*<Route exact path={routerPaths.voting} component={VotingPage} />*/}
        <Route exact path={routerPaths.burn} component={WalletPage2} />

        <Route path="*"><Redirect to={routerPaths.main} /></Route>
      </Switch>
    </ErrorBoundary>
  );
}

export default hot(module)(AppRouter);
